export default {
  "languageDisplayName": "Português",
  "greeting": "Olá",
  "Profile": "Perfil",
  "Interests": "Interesses",
  "Recurring Payments": "Pagamentos Recorrentes",
  "Payment Methods": "Métodos de Pagamento",
  "Transactions": "Transações",
  "Passport": "Passaporte",
  "Wallet": "Carteira",
  "Subscriptions": "Assinaturas",
  "Projects": "Projetos",
  "Campaigns": "Campanhas",
  "Volunteer": "Voluntário",
  "Events": "Eventos",
  "Settings": "Configurações",
  "My": "Meus",
  "Groups": "Grupos",
  "Awards": "Prêmios",
  "Change": "Mude a",
  "Image": "Imagem",
  "You have no": "Você não tem",
  "Now": "Agora",
  "Booths": "Cabines",
  "Add": "Adicionar",
  "You Might Like:": "Você Pode Gostar: ",
  "Start Date": "Data de início:",
  "End Date": "Data final: ",
  "Payment Method": "Método de pagamento",
  "Filter": "Filtro",
  "Download": "Download",
  "Saved Cards": "Cartões Salvos",
  "Saved Debits": "Débitos Salvos",
  "Recommended": "Recomendado",
  "Subscribe": "Se inscrever",
  "Unsubscribe": "Cancelar subscrição",
  "Click to": "Clique para se ",
  "Update": "Atualizar",
  "Register": "Registo",
  "Unregister": "Cancelar O Registro",
  "Add More Interests": "Adicionar mais interesses",
  "Add More Skills": "Adicione mais habilidades",
  "Search": "Pesquisa",
  "Close": "Fechar",
  "Debit": "Débit",
  "debit": "Débit",
  "Credit Card": "Cartão de crédito",
  "card": "Cartão de crédito",
  "Cancel": "Cancelar",
  "Save": "Salvar",
  "Account Name": "Nome da conta",
  "Institution Name": "Nome da Instituição",
  "BSB Number": "Número BSB",
  "Account Number": "Número da Conta",
  "Cardholder Name": "Nome do Titular",
  "Card Number": "Número do Cartão",
  "Expiration Date": "Data de Validade",
  "Cannot Be Empty": "Não pode estar vazio",
  "Not Valid": "Inválido",
  "Cannot Be Empty or Contain Numbers": "Não pode estar vazio ou conter números",
  "Login": "Entrar",
  "Logout": "Sair",
  "Offline": "Offline",
  "No Popups": "Nós notamos que você bloqueou pop-ups, certifique-se de habilitá-los para este site.",
  "Awaiting Login": "Aguardando Login",
  "Awaiting Registration": "Aguardando Registro",
  "Please": "Please",
  "Voting": "Votação",
  "Site Settings": "Configurações do site",
  "My Settings": "Minhas configurações",
  "Security Settings": "Configurações de segurança",
  "2-Factor Authentication": "Autenticação de 2 fatores",
  "Language": "Língua",
  "Name": "Nome",
  "Addresses": "Endereços",
  "Work": "Trabalhos",
  "Home": "Casa",
  "Other": "De outros",
  "Phone Numbers": "Números de telefone",
  "Email Addresses": "Endereço de e-mail",
  "First Name": "Primeiro nome",
  "Last Name": "Último nome",
  "Address Type": "Tipo de Endereço",
  "Street Address 1": "Endereço 1",
  "Street Address 2": "Endereço 2",
  "City": "Cidade",
  "State": "Estado",
  "Postcode": "CEP",
  "Country": "País",
  "Phone Number Type": "Tipo de Número de Telefone",
  "Email Type": "Tipo de email",
  "Custom Type": "Tipo Personalizado",
  "Number": "Número",
  "Email": "O email",
  "Emails": "Emails",
  "Phone": "Telefone",
  "Phones": "Telefones",
  "Address": "Endereço",
  "Add Address": "Adicionar Endereço",
  "Add Phone": "Adicionar Telefone",
  "Add Email": "Adicionar Email",
  "Accommodation": "Alojamento",
  "Mobile": "Móvel",
  "View": "Visão",
  "No Groups": "Você não tem grupos",
  "Recommended Groups": "Grupos Recomendados",
  "Roles": "Papéis",
  "Admin": "Admin",
  "Photos": "Fotos",
  "Join": "Junte-se",
  "Leave": "Sair",
  "Joined": "Ingressou",
  "Member": "Membro",
  "Members": "Membros",
  "Are you sure?": "Você tem certeza?",
  "Yes": "Sim",
  "No": "Não",
  "Fitness": "Ginástica",
  "Help": "Socorro",
  "Gallery": "Galeria",
  "Support": "Suporte",
  "Unsupport": "Não suportado",
  "Skills": "Habilidades",
  "Communities": "Comunidades",
  "Click here to enter": "Clique aqui para entrar",
  "Rooms": "quartos",
  "Boards": "Pranchas",
  "Cloud": "Nuvem",
  "Future": "Futuro",
  "Churches": "Igrejas",
  "Password": "Senha",
  "password": "senha",
  "New Password": "Nova senha",
  "Old Password": "Senha Antiga",
  "Confirm Password": "Confirme a Senha",
  "Subscribers": "Inscritos",
  "Browse": "Navegar",
  "Past Events": "Eventos passado",
  "Future Events": "Eventos futuros",
  "Create": "Crio",
  "Edit": "Editar",
  "Issues": "Problemas",
  "Organizer": "Organizador",
  "Next": "Próximo",
  "Back": "De Volta",
  "Confirm": "Confirme",
  "Select Payment Method": "Selecione O Método De Pagamento",
  "Please provide a payment method": "Por favor, forneça um método de pagamento",
  "Select A Support Level": "Selecione Um Nível De Suporte",
  "Your support will be sent from your selected payment method:": "Seu suporte será enviado pelo método de pagamento selecionado:",
  "My Gallery": "Minha Galeria",
  "Local Artists": "Artistas Locais",
  "My Fitness": "Minha Aptidão",
  "Next Due": "Próximo Vencimento",
  "Frequency": "Freqüência",
  "Status": "Status",
  "Link Your Fitbit": "Vincule Seu Fitbit",
  "Link Your Strava": "Vincule Seu Strava",
  "Active": "Ativo",
  "Cancelled": "Cancelado",
  "Tracker": "Rastreador",
  "Mobile Number": "Número De Celular",
  "Day": "Dia",
  "Month": "Mês",
  "Year": "Ano",
  "Date Of Birth": "Data de Nascimento",
  "Sign Up": "Inscrever-se",
  "Check In": "Check-In",
  "News": "Notícia",
  "Deregister": "Cancelar o registro",
  "What's On": "O que está acontecendo",
  "On Now": "Agora",
  "Coming Up": "Em breve",
  "There are currently no upcoming events": "Atualmente não há eventos programados",
  "Next Up": "Próximo",
  "Near Me": "Perto de mim",
  "Goals": "Metas",
  "Connect": "Conectar",
  "Select An Option": "Escolha Uma Opção",
  "Mentors": "Mentores",
  "Employment": "Emprego",
  "Log In": "Entrar",
  "Log Out": "Sair",
  "Please log in or sign up to continue.": "Faça o login ou registre-se para continuar.",
  "Add your group": "Adicione seu grupo",
  "Preferred": "Preferido",
  "Read More": "Leia mais",
  "Description": "Descrição",
  "Submit": "Enviar",
  "Subject": "Sujeita",
  "Message": "Mensagem",
  "Send Me A Copy": "Envie-me Uma Cópia",
  "Contacts": "Contatos",
  "Followers": "Seguidoras",
  "Follow": "Segue",
  "Following": "Seguinte",
  "Contact Number": "Número De Contato",
  "Any unsaved information may be lost": "Qualquer informação não salva pode ser perdida",
  "Add Location": "Adicionar localização",
  "Edit Location": "Editar localização",
  "Last Logged In": "Último login",
  "Your Connections": "Suas Conexões",
  "There are no connections currently linked to your account": "Não há conexões atualmente vinculadas à sua conta",
  "Connection Type": "Tipo de conexão",
  "Remove Connection": "Remover conexão",
  "Connect To: ": "Conecte ao: ",
  "Timezone": "Fuso horário",
  "forgotPassword": "Não sei minha senha",
  "createNewAccount": "Criar nova conta",
  "logInWith": "Faça login com o ",
  "orEnterYour": "ou use seu",
  "usernameOrEmail": "nome de usuário ou e-mail",
  "passwordRequired": "senha requerida",
  "enterPasswordFor": "digite a senha para",
  "authenticationFailed": "autenticação falhou",
  "signIn": "entrar",
  "iHaveAnAccount": "eu tenho uma conta",
  "termsAndPrivacy": "termos e privacidade",
  "securedBy": "protegido pelo",
  "Delete": "Excluir",
  "Please Wait": "Por favor, aguarde",
  "loadingDiscussions": "Estamos carregando suas discussões de bate-papo!",
  "No Discussions": "Sem discussões!",
  "joinDiscussion": "Participe de uma discussão para que ele seja exibido aqui!",
  "Discussion": "Discussão",
  "Log in with :": "Entrar com:",
  "Powered By:": "Alimentado Por:",
  "termsUpdated": "Aceite os termos e a política de privacidade mais recentes.",
  "Please accept the latest": "Por favor, aceite o mais recente",
  "Terms": "Termos",
  "terms": "termos",
  "Privacy Policy": "Política de Privacidade",
  "privacy policy": "política de privacidade",
  "willRecieveFollowingInfo": "receberá as seguintes informações:",
  "Email Address": "Endereço de Email",
  "and": "e",
  "We Use Cookies": "Usamos Cookies",
  "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Os cookies nos ajudam a lidar com muitos processos que nossa plataforma requer, aceite ou revise nossas configurações disponíveis",
  "ACCEPT ALL": "ACEITAR TUDO",
  "REJECT ALL": "REJEITAR TUDO",
  "ACCEPT CURRENT SELECTION": "ACEITAR A SELEÇÃO ATUAL",
  "SETTINGS": "CONFIGURAÇÕES",
  "Manage cookie preferences": "Gerenciar preferências de cookies",
  "Close modal": "Fechar modal",
  "Strictly Necessary cookies": "Cookies estritamente necessários",
  "These cookies are essential for the proper functioning of the website and cannot be disabled.": "Esses cookies são essenciais para o bom funcionamento do site e não podem ser desativados.",
  "Performance and Analytics": "Desempenho e análise",
  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.": "Esses cookies coletam informações sobre como você usa nosso site. Todos os dados são anonimizados e não podem ser usados para identificá-lo.",
  "ACCEPT REQUIRED": "ACEITAR NECESSÁRIO",
  "Terms and Privacy Policy Links": "Termos e links da política de privacidade",
  "Services": "Serviços",
  "Profile Pages": "Páginas de perfil",
  "Success": "Sucesso",
  "Your disconnection request has successfully been processed": "Sua solicitação de desconexão foi processada com sucesso",
  "Disconnecting will cause a new authorization prompt on next login to any related services": "A desconexão causará um novo prompt de autorização no próximo login em qualquer serviço relacionado",
  "Legal": "Jurídica",
  "Available Services": "Serviços Disponíveis",
  "Link": "Link",
  "Disconnect": "Desconectar",
  "Agreed": "Acordado"
};